var app = angular.module("leonardo");

var AccountUserRolesList = function ($scope, ngDialog, $controller, AccountUserRoleService, PermissionService,
                                     AccountUserService, FilterService, AuthDataService) {

  $scope.roleExpanded = null;
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;
  $scope.order = 'name';

  $scope.getEntitiesPromise = function (options) {
    var params = $scope.getParams();
    angular.forEach(params, function (value, key) {
      options[key] = value;
    });
    return AccountUserRoleService.getlist(options);
  };

  $scope.getParams = function () {
    $scope.params = {};
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) $scope.params['system'] = true;
    if (FilterService.hasFilter('user_role_search')) $scope.params['search'] = FilterService.getFilter('user_role_search');
    if (FilterService.hasFilter('account_reports')) $scope.params['account'] = FilterService.getFilter('account_reports');
    return $scope.params;
  };

  $scope.showDelete = function (role) {
    return PermissionService.isOwner() && isNull(role.base_type);
  }

  $scope.showEdit = function (role) {
    return PermissionService.isOwner() &&
      (isNull(role.base_type) || (role.base_type.toString() !== AccountUserRoleService.BASE_TYPE_EXTERNAL_APPROVER) || PermissionService.authDataService.isAdmin());
  }

  $scope.showCloneAdminDialog = function (role) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        onlyClientInstance: true,
        type: 'role',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        role.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function (data) {
          $scope.loadPage($scope.page);
        });
      }
    });
  };

  $scope.showRoleDeleteDialog = function (role) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account-user/delete-role.html',
      controller: 'DeleteRoleDialog',
      data: {
        role: role
      }
    }).then(function (data) {
      AccountUserRoleService.updateCollection(data, true);
      $scope.loadPage($scope.page);
    });
  };

  $scope.expandRole = function (role, disabled) {
    if ($scope.isRoleExpanded(role)) {
      $scope.roleExpanded = null;
      return;
    }
    role.disabled = disabled;
    role.specificdisabled = (AuthDataService.isAdmin() && (role.name == 'Account Owner')) || (['External Approver', 'External Manager']).includes(role.name);
    $scope.roleElement = role;
    AccountUserRoleService.get(role.id).then(function (data) {
      $scope.roleExpanded = role.id;
      $scope.roleElement.client_instance = data.client_instance;
    });
  };

  $scope.isRoleExpanded = function (role) {
    return $scope.roleExpanded && ($scope.roleExpanded == role.id);
  };

  $scope.$on('account-user-roles:updated', function () {
    $scope.roleExpanded = null;
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage($scope.page);
};

app.controller('AccountUserRolesList', ['$scope', 'ngDialog', '$controller', 'AccountUserRoleService',
  'PermissionService', 'AccountUserService', 'FilterService', 'AuthDataService', AccountUserRolesList]);
